import statistics from './src/statistics';
import implement from './src/implement';
import business from './src/business';
import user from './src/user';
import dict from './src/dict';

export default {
  statistics,
  implement,
  user,
  business,
  dict
};
